import http from '@/libs/http'

export const getGlobalData = () => {
  return http.request({
    url: '/global/getV2',
    params: {
      end: 'shop'
    },
    method: 'get'
  })
}

/**
 * 获取店铺设置
 */
export const getShopSetting = () => {
  return http.request({
    url: '/global/getShopSetting',
    params: {},
    method: 'get'
  })
}

export const getShopUISetting = ()=>{
  return http.request({
    url: '/global/getShopUISetting',
    method: 'get'
  })
}

export const getClerkSoundList = () => {
  return http.request({
    url: '/global/getClerkSoundList',
    params: {
    },
    method: 'get'
  })
}
